<template>
    <div>
        <div @click="closeCompleteAction" v-if="isOpen && isShowBackground" :style="{ zIndex: zIndex }" style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; background-color: rgba(0, 0, 0, 0.2); z-index: 10;"></div>
        <section @touchstart.stop="touchStart($event)" @touchmove.stop="touchMove($event)" @touchend.stop="touchEnd($event)" class="edit-page" :class="{ open: isOpen }" :style="{ transform: isOpen ? `translateY(${$GlobalStore.navigationBarHeight() + 'px'})` : 'translateY(100%)', bottom: calcBottom + 'px', height: constrainedChangeHeight, paddingBottom: changeBottom + 'px', zIndex: zIndex, backgroundColor: backgroundColor, background: background, backdropFilter: isBlur ? 'blur(100px)' : '', maxHeight: maxHeight === -1 ? '' : maxHeight + 'px' }">
            <slot></slot>
            <div :style="{ height: $GlobalStore.navigationBarHeight() + 'px' }"></div>
        </section>
    </div>
</template>

<script>
export default {
    name: "CommonPopupFrame",
    props: {
        hideBackground: {
            type: Boolean,
            default: false
        },
        isOpen: {
            type: Boolean,
            default: false,
        },
        closeCompleteAction: {
            type: Function,
            default: () => { }
        },
        closeType: {
            type: String,
            default: '',
        },
        changeHeight: {
            type: [Number, String],
            default: 90,
        },
        changeHeightUnit: {
            type: String,
            default: '%'
        },
        changeBottom: {
            type: Number,
            default: 90,
        },
        zIndex: {
            type: Number,
            default: 10
        },
        backgroundColor: {
            type: String,
            default: '#fff'
        },
        isBackPressApply: {
            type: Boolean,
            default: false,
        },
        background: {
            type: String,
            default: ''
        },
        isBlur: {
            type: Boolean,
            default: false
        },
        isShowBackground: {
            type: Boolean,
            default: true
        },
        maxHeight: {
            type: Number,
            default: -1
        }
    },
    watch: {
        isOpen() {
            if (!this.isBackPressApply) return;
            if (this.isOpen) {
                this.$GlobalStore.addPopFlag(this.closeCompleteAction);
            } else {
                this.closeCompleteAction();
            }
        },
        changeHeight() {
            this.setConstraintChangeHeight()
        }
    },
    data() {
        return {
            scrollY: 0,
            startY: 0,
            movePanelBottom: 0,
            lastOpen: false,
            isEndPhase: false,
            calcHeight: 0,
            calcBottom: 0,
            constrainedChangeHeight: '',
        }
    },
    methods: {
        setConstraintChangeHeight() {
            let option = '';

            if (this.changeHeightUnit === '%') {
                option = ' - ' + this.$GlobalStore.statusBarHeight() + 'px';
            } else {
                option = '';
            }

            if (this.changeHeight === 'auto') {
                this.constrainedChangeHeight = this.changeHeight;
            } else {
                this.constrainedChangeHeight = 'calc(' + this.changeHeight + this.changeHeightUnit + option + ')';
            }

        },
        touchStart(e) {
            const touch = e.touches[0] || e.changedTouches[0];
            this.startY = touch.pageY;
            this.startScrollY = this.scrollY;
        },
        touchMove(e) {
            const touch = e.touches[0] || e.changedTouches[0];
            const difference = touch.pageY - this.startY;
            this.scrollY = this.startScrollY + difference;

            if (this.scrollY < 0) {
                return
            }
            this.calcBottom = -this.scrollY;
        },
        touchEnd() {
            if (Math.abs(this.startScrollY - this.scrollY) > 50 && this.scrollY > 0) {
                this.closeCompleteAction(this.closeType);
                setTimeout(() => {
                    this.calcBottom = 0
                    this.scrollY = 0
                }, 500)
            } else {
                this.calcBottom = 0
                this.scrollY = 0
            }
        },
    },
    created() {
        this.setConstraintChangeHeight()
    }
}
</script>

<style scoped>
.edit-page {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    display: flex;
    flex-direction: column;
    background: #fff;
    transform: translateY(100%);
    transition: transform 0.5s, height 0.5s;
    animation-timing-function: ease-out;
    border-top-left-radius: 25px;
    border-top-right-radius: 25px;
    /* padding-bottom: 90px; */
    box-sizing: border-box;
}

.edit-page.open {

}
</style>